import * as gsf from "../../game-state-functions.js";
import * as random from "../../util/random.js";

var type = "wormSwitch";

// Compute the owner reassignment WITHOUT applying it (split from apply so the host can compute the
// map once, ship it to every client, and apply the SAME map at the freeze instant). Swap at the
// PLAYER level, not per worm: every worm a player controls moves to ONE new owner together, so a
// twin pair is never split across two players (which would leave two worms overlapping with
// mismatched owners/immunity). Returns {oldPlayerId: newPlayerId}, or null if <2 players have worms.
function computeAssignments(gameState) {
    var aliveWorms = gsf.getAliveWorms(gameState);
    var owners = [];
    aliveWorms.forEach(function (worm) {
        if (owners.indexOf(worm.playerId) === -1) { owners.push(worm.playerId); }
    });
    if (owners.length < 2) { return null; } // only one player left with worms: nothing to switch
    // Derangement (no fixed points), so every player genuinely changes worms.
    var perm = random.randomPermutation(gameState, owners.length, true);
    var ownerMap = {};
    for (var i = 0; i < owners.length; i++) { ownerMap[owners[i]] = owners[perm[i]]; }
    return ownerMap;
}

function applyAssignments(gameState, ownerMap) {
    if (!ownerMap) { return; }
    gsf.getAliveWorms(gameState).forEach(function (worm) {
        if (ownerMap[worm.playerId] !== undefined) { worm.playerId = ownerMap[worm.playerId]; }
        // Remove AI trajectories tied to the old owner. TODO: nicer trajectory handling (ML).
        worm.trajectory = undefined;
    });
    // NB: we deliberately do NOT create a fresh segment here. With stable track keys (worm.trackId)
    // the trail continues under the same key - the next segment (streamed by the new owner's client,
    // or produced by the normal loop for a bot) simply carries the new playerId, so the colour turns
    // over there. Calling updateWorms(0) would append a segment at worm.centerX/centerY, which for a
    // client-authoritative worm is STALE (its spawn point) - teleporting the head back to spawn and
    // crashing it into its own start-of-trail the instant it's handed over.
}

function activate({ gameState }) {
    applyAssignments(gameState, computeAssignments(gameState));
}

export {
    type,
    activate,
    computeAssignments,
    applyAssignments
};
